import { useState, useEffect } from 'react';
import { CalendarClock, Loader2 } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

export default function AdminContentSchedule() {
  const { authFetch } = useAdmin();
  const [days, setDays] = useState(14);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    authFetch(`${API}/admin/content-schedule?days=${days}`).then(r => r.json()).then(d => { setData(d); setLoading(false); });
  }, [authFetch, days]);

  return (
    <div data-testid="admin-content-schedule">
      <AdminPageHeader icon={CalendarClock} title="Raspored sadržaja" subtitle="Nadolazeći zakazani članci">
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="schedule-days"
                className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm">
          <option value={7}>Sljedećih 7 dana</option>
          <option value={14}>Sljedećih 14 dana</option>
          <option value={30}>Sljedećih 30 dana</option>
        </select>
      </AdminPageHeader>
      <div className="px-4 md:px-6 pb-6 overflow-x-auto rounded-lg border border-zinc-800 mx-4 md:mx-6">
        {loading ? <Loader2 className="animate-spin m-4"/> : (
          <table className="min-w-full text-sm">
            <thead className="bg-zinc-900 text-xs text-zinc-400 uppercase">
              <tr>
                <th className="px-4 py-2 text-left">Naslov</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Zakazano</th>
              </tr>
            </thead>
            <tbody>
              {(data?.items || []).map(a => (
                <tr key={a.id} className="border-t border-zinc-800 hover:bg-zinc-900/50">
                  <td className="px-4 py-2">{a.title}</td>
                  <td className="px-4 py-2">{a.status}</td>
                  <td className="px-4 py-2 text-xs text-zinc-500">{(a.scheduled_at || '').slice(0, 16).replace('T', ' ')}</td>
                </tr>
              ))}
              {(data?.items || []).length === 0 && (
                <tr><td colSpan={3} className="px-4 py-8 text-center text-zinc-500">Nema zakazanih članaka.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
